import React from "react";
import { Typography } from "@material-ui/core";

import { VARIABLES } from "./codeSamples";

const FIELDS = [
  ["number", "texto", "sim", "Código do país + DDD + número, só dígitos. Ex.: 5511987654321"],
  ["body", "texto", "sim, em texto", "A mensagem. Em arquivos vira a legenda (sem ela, a legenda é o nome do arquivo)."],
  ["name", "texto", "não", "Nome usado se o contato ainda não existir."],
  ["medias", "arquivo(s)", "não", "Um ou mais arquivos, enviados como multipart/form-data."],
  ["closeTicket", "booleano", "não", "true encerra o atendimento logo após o envio."],
];

const RESPONSES = [
  ["200", "green", "Mensagem aceita", '{"mensagem":"Mensagem enviada"}'],
  ["401", "red", "Token ausente ou inválido", '{"error":"Acesso não permitido"}'],
  ["400", "amber", "Número inválido, sem WhatsApp ou mensagem vazia", '{"error":"…"}'],
];

const DocsPanel = ({ classes, endpoint }) => (
  <div className={classes.docs}>
    <section>
      <Typography component="h3" className={classes.docsTitle}>Como funciona</Typography>
      <Typography variant="body2" className={classes.docsText}>
        Cada mensagem enviada pela API cria ou atualiza o contato e abre (ou reaproveita) um
        atendimento em Atendimentos, como uma conversa iniciada pelo sistema.
      </Typography>
      <div className={classes.endpoint}>
        <span className={classes.method}>POST</span>
        <code>{endpoint}</code>
      </div>
    </section>

    <section>
      <Typography component="h3" className={classes.docsTitle}>Autenticação</Typography>
      <Typography variant="body2" className={classes.docsText}>
        Envie o token da conexão no cabeçalho <code>Authorization: Bearer SEU_TOKEN</code>. O token
        escolhe por qual número a mensagem sai. Gere ou troque o token na aba Testar envio.
      </Typography>
    </section>

    <section>
      <Typography component="h3" className={classes.docsTitle}>Campos</Typography>
      <div className={classes.tableScroll}>
        <table className={classes.table}>
          <thead>
            <tr><th>Campo</th><th>Tipo</th><th>Obrigatório</th><th>Descrição</th></tr>
          </thead>
          <tbody>
            {FIELDS.map(([field, type, required, desc]) => (
              <tr key={field}>
                <td><code>{field}</code></td><td>{type}</td><td>{required}</td><td>{desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>

    <section>
      <Typography component="h3" className={classes.docsTitle}>Variáveis na mensagem</Typography>
      <div className={classes.tableScroll}>
        <table className={classes.table}>
          <tbody>
            {VARIABLES.map((v) => (
              <tr key={v.key}><td><code>{v.key}</code></td><td>{v.label}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>

    <section>
      <Typography component="h3" className={classes.docsTitle}>Respostas</Typography>
      <div className={classes.tableScroll}>
        <table className={classes.table}>
          <thead>
            <tr><th>Código</th><th>Quando</th><th>Corpo</th></tr>
          </thead>
          <tbody>
            {RESPONSES.map(([code, tone, when, body]) => (
              <tr key={code}>
                <td><span className={`${classes.pill} ${classes[`pill_${tone}`]}`}>{code}</span></td>
                <td>{when}</td>
                <td><code>{body}</code></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>

    <div className={classes.note}>
      Evite disparos em massa por esta API: para listas grandes use Campanhas. Muitos envios
      seguidos para números diferentes aumentam o risco de bloqueio do WhatsApp.
    </div>
  </div>
);

export default DocsPanel;
